import { writable, Writable } from "svelte/store";
import type { IGetCurrentUserDataRes } from "./backend/users.generated.types";

export const is_admin: Writable<boolean> = writable(false);
export const is_power: Writable<boolean> = writable(false);
export const is_short: Writable<boolean> = writable(false);
export const is_logged_in: Writable<boolean> = writable(false);
export const token: Writable<string> = writable("");
export const username: Writable<string> = writable("");
export const title: Writable<string> = writable("");
export const user_data: Writable<IGetCurrentUserDataRes | null> = writable(null);

/** Flag if wide-screens should be used */
export const enable_wide_gui: Writable<boolean> = writable(false);

const LOCAL_STORAGE_ENABLE_WIDE = "gui.enable_wide_display";

export function initStores() {
    // read initial value from local storage
    const initial_value = (localStorage.getItem(LOCAL_STORAGE_ENABLE_WIDE) == "true");
    enable_wide_gui.set(initial_value);

    // set listener that will store the value back
    enable_wide_gui.subscribe(val => {
        localStorage.setItem(LOCAL_STORAGE_ENABLE_WIDE, "" + val);
    });
}
